"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const colorswatch = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-colorswatch` : '') + (description ? ` desc-colorswatch` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-colorswatch"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-colorswatch"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_1996)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.93313 0C9.35654 0 9.69978 0.335786 9.69978 0.75L9.699 18.252L16.1359 4.249L16.1508 4.21093C16.2064 4.05263 16.2062 3.88064 16.1503 3.72247L16.1336 3.67969C16.0616 3.51013 15.9288 3.37281 15.7609 3.29299L15.7183 3.27425L11.467 1.55725C11.0756 1.39918 10.8893 0.96067 11.0509 0.577801C11.2072 0.207282 11.6321 0.0246568 12.014 0.156515L12.0521 0.170754L16.3034 1.88776C16.8672 2.1155 17.3155 2.55304 17.5496 3.10412C17.7743 3.63316 17.7839 4.22523 17.5783 4.75976L17.5515 4.82626L17.5421 4.84756L10.614 19.921L21.7212 10.6772L21.7496 10.6504C21.8689 10.5305 21.9438 10.3749 21.9622 10.2085L21.9658 10.1629C21.9747 9.97944 21.9145 9.79979 21.7976 9.65758L21.7672 9.62283L18.6709 6.29483C18.3859 5.9885 18.4087 5.51415 18.7219 5.23534C19.0242 4.96614 19.4866 4.97766 19.7747 5.2545L19.8049 5.28517L22.9012 8.61325C23.3117 9.05463 23.5262 9.63748 23.4974 10.2336C23.4698 10.8067 23.2194 11.347 22.7991 11.7447L22.7479 11.7917L22.7287 11.8082L9.699 22.651L9.69978 23.25C9.69978 23.6297 9.41136 23.9435 9.03716 23.9932L8.93313 24H1.26665C0.84324 24 0.5 23.6642 0.5 23.25V0.75C0.5 0.335786 0.84324 0 1.26665 0H8.93313ZM8.166 15H2.033L2.0333 22.5L7.98792 22.5001C7.97652 22.3126 8.03696 22.1228 8.16576 21.9729L8.166 15ZM5.14504 18.7509C5.75923 18.774 6.24986 19.2685 6.24986 19.875C6.24986 20.4963 5.735 21 5.09989 21C4.46478 21 3.94992 20.4963 3.94992 19.875C3.94992 19.2685 4.44055 18.774 5.05473 18.7509H5.14504ZM8.166 10.5H2.033V13.5H8.166V10.5ZM8.166 6H2.033V9H8.166V6ZM8.16648 1.5H2.0333L2.033 4.5H8.166L8.16648 1.5Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_1996"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = colorswatch;